var _rect, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#DCEFE1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 17.5V13.5498C10.3333 13.2508 10.3333 13.1013 10.3939 12.9871C10.4471 12.8867 10.5321 12.805 10.6367 12.7539C10.7555 12.6957 10.9111 12.6957 11.2222 12.6957H12.7778C13.0889 12.6957 13.2445 12.6957 13.3633 12.7539C13.4679 12.805 13.5529 12.8867 13.6061 12.9871C13.6667 13.1013 13.6667 13.2508 13.6667 13.5498V17.5M11.4543 7.76539L7.68633 10.5813C7.43446 10.7696 7.30852 10.8637 7.21779 10.9815C7.13743 11.0859 7.07756 11.2036 7.04113 11.3286C7 11.4698 7 11.6231 7 11.9297V15.7918C7 16.3897 7 16.6887 7.1211 16.9171C7.22763 17.118 7.39761 17.2813 7.60668 17.3836C7.84436 17.5 8.1555 17.5 8.77778 17.5H15.2222C15.8445 17.5 16.1556 17.5 16.3933 17.3836C16.6024 17.2813 16.7724 17.118 16.8789 16.9171C17 16.6887 17 16.3897 17 15.7918V11.9297C17 11.6231 17 11.4698 16.9589 11.3286C16.9224 11.2036 16.8626 11.0859 16.7822 10.9815C16.6915 10.8637 16.5655 10.7696 16.3137 10.5813L12.5457 7.76539C12.3505 7.61952 12.253 7.54659 12.1452 7.51855C12.0501 7.49382 11.9499 7.49382 11.8548 7.51855C11.747 7.54659 11.6495 7.61952 11.4543 7.76539Z",
    stroke: "url(#paint0_linear_42_217037)",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_42_217037",
    x1: 7,
    y1: 7.5,
    x2: 17.1708,
    y2: 7.67682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004C3B"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/IconHome.d825852aa41adcef8b898b24923bedb4.svg";
export { ForwardRef as ReactComponent };